import { OrderDraftPricesFragment as OrderDraftPricesFragmentType } from '@/features/graphql/generated/graphql'
import { OrderDraftPricesFragment } from '@/features/pos/components/OrderFinalization/fragments/orderDraftPrices'
import { useFragment } from '@apollo/client'

export const useOrderDraftPricesCache = (): OrderDraftPricesFragmentType | undefined => {
    const { data, complete } = useFragment({
        fragment: OrderDraftPricesFragment,
        from: { __typename: 'OrderDraft' },
    })

    return complete ? data : undefined
}
